var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadadPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 412.544,
    height: 106.259,
    viewBox: "0 0 412.544 106.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(-7911.935 -2049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M392.492,250.7c-1.478,4.384-27.3,75.246-35.92,98.814l-.021.019a.46.46,0,0,1-.05.15c-1.571,4.094-6.029,7.275-10.161,7.275H332.586c8.358-22.884,27.617-75.667,38.687-106.259Z",
    transform: "translate(7685.621 1798.304)",
    fill: "#939595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M612.622,298.883l-8.845,24.276c-1.527,4.189-6.073,7.59-10.262,7.59l-14.7-.006a39.279,39.279,0,0,0,3.747-7.589l8.862-24.267H570.137l-8.827,24.267c-1.524,4.174-6.106,7.589-10.3,7.589l-7.081.006H536.3a38.4,38.4,0,0,0,3.736-7.59l8.866-24.276h-21.27l-8.843,24.276c-1.522,4.189-6.1,7.59-10.281,7.59l-67.915,0a37.26,37.26,0,0,0,3.793-7.445l2.244-6.22c5.786-15.906-2.448-28.844-18.346-28.844H404.083L396.377,309.5h24.2c4.185,0,6.342,3.4,4.825,7.585l-2.359,6.22c-1.525,4.184-6.055,7.44-10.238,7.44H377.873l-7.721,21.259H585.9c15.9,0,33.306-12.8,39.087-28.7l8.92-24.426Z",
    transform: "translate(7690.57 1803.251)",
    fill: "#ee7623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M294.844,352.008H238.687l7.737-21.259h56.157c4.185,0,8.826-3.4,10.351-7.59l2.2-6.071c1.527-4.189-.65-7.585-4.829-7.585H275.433l7.707-21.259h34.866c15.907,0,24.137,12.938,18.347,28.844l-2.171,6.071c-5.79,15.9-23.432,28.849-39.339,28.849",
    transform: "translate(7673.248 1803.251)",
    fill: "#ee7623"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadadPayment);
export default __webpack_public_path__ + "static/media/Sadad_Payment.8316728f3086e6185cc5aab0afdb278c.svg";
export { ForwardRef as ReactComponent };